/*
 * Public API Surface of misc
 */

export * from './components/ngkit-progress-spinner/ngkit-progress-spinner.component';
